import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "601697ea-378d-479d-8ef8-736f8fe5d485",
    content: "All parameters indicate very poor performance.",
    options: {},
  },
  {
    id: "ff621da3-48cd-42f5-a640-3d9ba0d616dd",
    content: "All parameters indicate excellent performance.",
    options: {},
  },
  {
    id: "5bbcb8e5-fd71-4dcc-afa9-6f755a2c3cc1",
    content:
      "The airborne sound insulation of the party wall is excellent; the impact sound insulation of the floor is very poor; the façade sound insulation of the outer wall is very poor; the sound level due to service equipment is very low.",
    options: {},
  },
  {
    id: "6faab1dc-c6e0-4ee0-a781-678ea22b6fe2",
    content:
      "The airborne sound insulation of the party wall is very poor; the impact sound insulation of the floor is excellent; the façade sound insulation of the outer wall is quite good; the sound level due to service equipment is high.",
    options: {},
  },
  {
    id: "041e8368-9458-4d38-839e-8d4491c5bec0",
    content:
      "The airborne sound insulation of the party wall is average; the impact sound insulation of the floor is average; the façade sound insulation of the outer wall is very bad; the sound level due to service equipment is tolerable.",
    options: {},
  },
];

export const task: Task = {
  id: "d2240194-2211-42c1-b12e-083e3aa66a2e",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["6faab1dc-c6e0-4ee0-a781-678ea22b6fe2"],
};
